import { render, staticRenderFns } from "./favour.vue?vue&type=template&id=1a7bd365&"
import script from "./favour.vue?vue&type=script&lang=js&"
export * from "./favour.vue?vue&type=script&lang=js&"
import style0 from "./favour.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports